import { Component, ElementRef, Input, OnInit, OnDestroy, TemplateRef, ViewChild, EventEmitter, Output } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonService } from "../../services/commonService";
import { FormControl, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: 'app-guyana-home-screen',
  templateUrl: './guyana-home-screen.component.html',
  styleUrls: ['./guyana-home-screen.component.css']
})
export class GuyanaHomeScreenComponent implements OnInit {

@ViewChild("responseModel") responseModel: TemplateRef<any>;
  @ViewChild("successModal") successModal: TemplateRef<any>;
  @ViewChild("cashinoutModel") cashinoutModel: TemplateRef<any>;
  uuid: any;
  userId: any;
  isUserAccess: any;
  errorMessage: string;
  countryCodes = [];
  successMessage: string;
  transactionForm = new FormGroup({
    countryCode: new FormControl('', Validators.required),
    phone: new FormControl('', Validators.required),
    amount: new FormControl('', Validators.required),
    otp: new FormControl('')
  })
  constructor(
    private commonService: CommonService,
    private router: Router,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.getDropdownList();
    this.isUserCanAddOrEdit();

  }
  generateUUID() {
    var deviceId: String = this.userId.toString();
    while (deviceId.length < 8) deviceId = "0" + deviceId;
    deviceId = deviceId.split("").reverse().join("") + deviceId;
    var deviceNumber = Number(deviceId);
    return (this.uuid = "WEB_" + deviceNumber.toString(36).toUpperCase());
  }
  getDropdownList() {
    let body = { dropdown: ["merchants", "countryCodes"] };
    document.getElementById("loader").style.display = "block";
    this.commonService.getDropdownValues(body).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == "") {
        this.userId = res.userInfo.userId;
        this.countryCodes = res.list.countryCodes;
        if(res.list.countryCodes) {
          this.transactionForm.controls.countryCode.setValue(this.countryCodes[0].id);
        }

        this.generateUUID();

      } else {
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }

  isUserCanAddOrEdit() {
    let body = {
      deviceId: this.uuid,
      clientType: this.commonService.getClientType(),
      clientIp: this.commonService.getClientIP(),
    };
    document.getElementById("loader").style.display = "block";
    this.commonService.getAccessToFintech(body).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == '') {
        this.isUserAccess = res;
      } else {
        this.modalService.dismissAll();
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }

  gotoPath(route: string, key: string) {

    CommonService.fintechScreenName = key;
    this.router.navigateByUrl(route);

  }

  transactionType = '';
  showHide = false;
  isSubmitted = false;
  successData: any;

  max10Length(event) {
    if (event.target.value.length > 10) {
      this.transactionForm.controls.phone.setValue(event.target.value.slice(0, 10));
    }
  }

  openCashinoutModal(type) {
    this.transactionType = type;
    this.showHide = false;
    this.formReset();
    this.modalService.open(this.cashinoutModel, {backdrop: 'static', keyboard: false });
  }

  sendOtpforTxn() {
    if (!this.transactionForm.valid) {
      this.isSubmitted = true;
      return;
    }

    let body = {
      "amount": this.transactionForm.controls.amount.value,
      "consumerId": this.transactionForm.controls.countryCode.value + this.transactionForm.controls.phone.value,
      "otp": "",
      "transactionType": this.transactionType
    }

    document.getElementById("loader").style.display = "block";
    this.commonService.cashinOut(body).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == '') {
        this.showHide = true;
        this.transactionForm.controls.otp.setValidators(Validators.required);
        this.transactionForm.controls.otp.updateValueAndValidity();
      } else {
        this.modalService.dismissAll();
        this.formReset();
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }

  confirmTransaction() {
    if (!this.transactionForm.valid) {
      this.isSubmitted = true;
      return;
    }
    let body = {
      "amount": this.transactionForm.controls.amount.value,
      "consumerId": this.transactionForm.controls.countryCode.value + this.transactionForm.controls.phone.value,
      "otp": this.transactionForm.controls.otp.value,
      "transactionType": this.transactionType
    }

    document.getElementById("loader").style.display = "block";
    this.commonService.cashinOut(body).subscribe((res) => {
      document.getElementById("loader").style.display = "none";
      if (res.message.errorMessage == '') {
        this.modalService.dismissAll();
        this.successMessage = res.message.successMessage;
        this.successData = res.getTransactions.transactions[0];
        this.formReset();
        this.modalService.open(this.successModal, { backdrop: 'static', keyboard: false , windowClass: "successModal" });
      } else {
        this.modalService.dismissAll();
        this.showHide = false;
        this.transactionForm.controls.otp.clearValidators();
        this.transactionForm.controls.otp.updateValueAndValidity();
        this.errorMessage = res.message.errorMessage;
        this.modalService.open(this.responseModel, { backdrop: 'static', keyboard: false });
      }
    });
  }

  close() {
    this.showHide = false;
    this.isSubmitted = false;
    this.transactionForm.controls.otp.clearValidators();
    this.transactionForm.controls.otp.updateValueAndValidity();
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  formReset() {
    this.showHide = false;
    this.isSubmitted = false;
    this.transactionForm.controls.otp.clearValidators();
    this.transactionForm.controls.otp.updateValueAndValidity();
    this.transactionForm.reset();
    this.transactionForm.controls.countryCode.setValue(this.countryCodes[0].id);
  }
}

